<template>
  <NuxtLayout>
    <NuxtPage/>
  </NuxtLayout>
</template>

<script setup>

</script>
<style lang="scss">
body {
  font-family: 'Nunito', sans-serif;
  font-size: 14px;
  line-height: 140%;
}

:root {
  --dark-grey: #141A1F;
  --yellow-primary: #FFDC00;
  --blue-primary: #207ED5;
  --grey-200: #EAEDF0;
  --grey-400: #B1B5B9;
  --grey-500: #999EA4;
  --grey-700: #585F65;
  --grey-800: #3B4044;
  --blue-bg: rgba(32, 126, 213, 0.07);
  --blue-hover: rgba(32, 126, 213, 0.2);
  --error: #E66100;
  --green-bg: rgba(64, 160, 67, 0.3);
  --red:#E66100;
}

.btn {
  font-weight: 600;
  font-size: 16px;
  line-height: 110%;
  text-align: center;
  color: var(--dark-grey);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  border-radius: 6px;
  transition: 0.2s;
  &:disabled{
    background-color: var(--grey-200);
  }
}

.btn__primary {
  background-color: var(--yellow-primary);
  &:hover{
    background-color: #E6C700;
  }
  &:active{
    background-color: #CAAE2B;
  }
  &:disabled{
    background-color: #EAEDF0;
    color: #999EA4;
  }

}
.btn__orange {
  background-color: #E66100;
  color: white;
  &:hover{
    background-color: #D65A00;
  }
  &:active{
    background-color: #C75400;
  }
  &:disabled{
    background-color: #EAEDF0;
    color: #999EA4;
  }
}
.btn__secondary {
  background-color: var(--grey-200);
  &:hover{
    background-color: #D5D9DD;
  }
  &:active{
    background-color: #B1B5B9;
  }
  &:disabled{
    background-color: #EAEDF0;
    color: #999EA4;
  }
}
.btn__link{
  background-color: transparent;
  color: var(--red);
}
.group[data-invalid] .group-data-\[invalid\]\:ring-1{
  box-shadow: none!important;
}
.focus\:ring-0:focus, .focus-within\:\!border-\[\#207ED5\]:focus-within, .focus-within\:ring-1:focus-within{
  box-shadow: none!important;
}
input:focus{
  border-color: var(--blue-primary) !important;
}
.focus-within\:\!ring-blue-400:focus-within{
  border-color: var(--blue-primary) !important;
}
</style>